import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'fi-user-locked-information',
    templateUrl: './user-locked-information.component.html',
    styleUrls: ['./user-locked-information.component.scss'],
    standalone: false,
})
export class UserLockedInformationComponent implements OnInit {
    @Input('user') User: any;

    constructor() {}

    ngOnInit() {}
}
